import { createAction } from "@reduxjs/toolkit";

/**
 * Marks an authenticated identity change within the current browser tab.
 *
 * Data fetched or projected for one principal must never remain available to the next principal.
 * The root reducer handles this action by rebuilding all in-memory state from its initial values.
 */
export const principalChanged = createAction("session/principalChanged");
